import { PostPatch, PostPatchStatus } from 'types/PostDetail';

export const formatPatchesToRequestData = (
  patches: (PostPatch & { status: PostPatchStatus })[],
): {
  id: number;
  status: PostPatchStatus;
}[] => {
  const postTypePatch = patches.find((patch) => patch.postColumn === 'type');
  const postSubtypePatch = patches.find(
    (patch) => patch.postColumn === 'subtype',
  );
  let result = patches.filter(
    (patch) => patch.postColumn !== 'type' && patch.postColumn !== 'subtype',
  );

  if (postSubtypePatch) {
    result = [
      {
        ...postSubtypePatch,
        status: postTypePatch?.status ?? postSubtypePatch.status,
      },
      ...result,
    ];
  }

  if (postTypePatch) {
    result = [{ ...postTypePatch }, ...result];
  }

  return result.map(({ id, status }) => ({ id, status }));
};
